import ViewPosts from './ViewPosts';
export default ViewPosts;
